import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import IMG_SURA from '@assets/images/background-sura.png';

interface StyleProps {
  isMobile: boolean;
}

const useStyles = makeStyles<Theme, StyleProps>(() =>
  createStyles({
    root: {
      padding: ({ isMobile }: StyleProps) =>
        isMobile ? '25px 14px 20px !important' : '80px 40px 140px 40px !important',
      backgroundImage: `url(${IMG_SURA})`,
      maxWidth: '100%',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      justifyContent: 'center',
      display: 'flex',
    },
    paymentMethod: {
      width: ({ isMobile }: StyleProps) => (isMobile ? 'auto' : '668px'),
      display: 'flex',
      justifyContent: 'center',
    },
    subscriptionPaymentMethod: {
      width: ({ isMobile }: StyleProps) => (isMobile ? 'auto' : '668px'),
      padding: ({ isMobile }: StyleProps) => (isMobile ? '0px' : '0px 122px'),
    },
  }),
);

export default useStyles;
